const InstagramIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10906_32025)">
        <path
          d="M9.99998 0.833008C8.18699 0.833008 6.41471 1.37062 4.90726 2.37787C3.39981 3.38512 2.22489 4.81675 1.53109 6.49174C0.837285 8.16673 0.655754 10.0098 1.00945 11.788C1.36315 13.5662 2.23619 15.1995 3.51817 16.4815C4.80015 17.7635 6.43349 18.6365 8.21165 18.9902C9.98981 19.3439 11.8329 19.1624 13.5079 18.4686C15.1829 17.7748 16.6145 16.5998 17.6218 15.0924C18.629 13.5849 19.1666 11.8127 19.1666 9.99967C19.1666 7.56852 18.2009 5.23694 16.4818 3.51786C14.7627 1.79878 12.4311 0.833008 9.99998 0.833008ZM12.6077 6.79858C12.6077 6.97105 12.5353 7.0398 12.3664 7.0398C12.042 7.0398 11.7175 7.0398 11.3943 7.05307C11.071 7.06634 10.8949 7.21349 10.8949 7.55121C10.8877 7.91305 10.8949 8.26765 10.8949 8.63673H12.2832C12.481 8.63673 12.5486 8.70428 12.5486 8.90329C12.5486 9.38575 12.5486 9.87061 12.5486 10.3579C12.5486 10.5545 12.4858 10.616 12.2868 10.6172H10.8829V14.542C10.8829 14.7519 10.8177 14.8182 10.6103 14.8182H9.1002C8.91807 14.8182 8.84691 14.747 8.84691 14.5649V10.6232H7.64801C7.45985 10.6232 7.39231 10.5545 7.39231 10.3651C7.39231 9.87705 7.39231 9.38936 7.39231 8.90208C7.39231 8.71393 7.46347 8.64276 7.64921 8.64276H8.84691V7.58739C8.8327 7.11333 8.94644 6.64419 9.17619 6.22928C9.41502 5.81039 9.79773 5.4924 10.2533 5.33432C10.5489 5.22675 10.8614 5.17284 11.176 5.17511H12.3616C12.5317 5.17511 12.6028 5.24989 12.6028 5.41634C12.6089 5.8807 12.6089 6.34024 12.6077 6.79858Z"
          fill="#1778F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_10906_32025">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InstagramIcon;
